import type { IAppliedFilterChip } from '../../../../types/data_table';

import { Dropdown } from '../../../Dropdown';
import { DropdownButton } from '../../../Dropdown/DropdownButton';

/** Longest text value shown on a chip before it is cut short. */
const MAX_CHIP_TEXT_LENGTH = 50;

const truncateText = (text: string, maxLength = MAX_CHIP_TEXT_LENGTH): string =>
  text.length <= maxLength ? text : `${text.substring(0, maxLength)}...`;

/**
 * A read-only chip standing for one applied text, phone or search value.
 *
 * It is a `Dropdown` with no menu purely so it looks and clears like the
 * filters beside it; there is nothing to open.
 */
export const AppliedFilterChip = ({
  filter,
  disabled,
  onClear,
}: IAppliedFilterChip) => {
  const { type, label, value } = filter;

  if (!value) return null;

  return (
    <Dropdown width="fit-content">
      <DropdownButton
        hideDropdownChevron
        label={label}
        text={type === 'text' ? truncateText(value) : value}
        // Phone numbers read left-to-right even in an Arabic layout.
        direction={type === 'phone' ? 'ltr' : undefined}
        disabled={disabled}
        onClearHandler={onClear}
      />
    </Dropdown>
  );
};
